import { prioritize, PrioritySelection } from "../models/favorite-sorting-models";

export function insertionSort<T extends PrioritySelection, K extends T>(array:Array<K>){
    var currentValue:K;
    for(var i = 0; i < array.length; i++){
        currentValue = array[i];
        
        for(
            var j = i - 1; 
            j >= 0 && (prioritize(array[j].typeDescription) > prioritize(currentValue.typeDescription)); 
            j--
        ){
            array[j+1] = array[j];
        }

        array[j+1] = currentValue;
    }

    return array;
}